export default class Utente{
    Username;
    DatiLoginUtente;
    DatiUtente;
    DatiCompany;
    IndirizziSpedizione;
    IndirizziFatturazione;
    MetodiDiPagamento;
    constructor(){}
}